import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AgencyReadSchemaRequest from '@careerstart/wae-common/schema/agency/read.post.req.json';

import { validateSchema } from '../../../../components/Form/validations';
import {
  selectAgencyDetail,
  selectIsAgencyLoading,
} from '../../../../store/selectors/dashboardSelector';
import { getAgencyForAgencyDetail } from '../../dashboardReducer';

/**
 * Custom hook for fetching admin agency specific data
 * Uses agency-specific API filtered by agency ID
 * @param {string} agencyId - The agency ID to fetch data for
 */
const useAdminAgencySpecificDataFetching = (agencyId) => {
  const dispatch = useDispatch();
  const agencyDetail = useSelector(selectAgencyDetail);
  const isGetAgencyLoading = useSelector(selectIsAgencyLoading);

  useEffect(() => {
    if (!agencyId) return;

    const payload = {
      filters: [
        {
          operation: 'equalsID',
          field: '_id',
          value: agencyId,
        },
      ],
    };
    const schemaErrors = validateSchema(payload, AgencyReadSchemaRequest);

    if (Object.keys(schemaErrors).length === 0) {
      dispatch(getAgencyForAgencyDetail(payload));
    }
  }, [dispatch, agencyId]);

  return {
    agencyDetail,
    isGetAgencyLoading,
  };
};

export default useAdminAgencySpecificDataFetching;
